import { createUseStyles } from "react-jss";
import type { VetBoatsTheme } from "../../theme";

type Tone = "neutral" | "success" | "danger" | "info" | "warning";

const useStyles = createUseStyles((theme: VetBoatsTheme) => ({
  badge: {
    display: "inline-block",
    padding: "2px 8px",
    borderRadius: 999,
    fontSize: 12,
    fontWeight: 600,
    whiteSpace: "nowrap",
  },
  neutral: { background: theme.color.background, color: theme.color.muted },
  success: { background: theme.color.successBg, color: theme.color.success },
  danger: { background: theme.color.dangerBg, color: theme.color.danger },
  info: { background: theme.color.infoBg, color: theme.color.info },
  warning: { background: "#fdf3dc", color: "#8a5a00" },
}));

export const Badge = ({ tone, children }: { tone: Tone; children: string }) => {
  const classes = useStyles();
  return (
    <span className={`${classes.badge} ${classes[tone]}`}>{children}</span>
  );
};
